import {
    MDBBtn,
    MDBDatatable,
    MDBIcon,
    MDBSpinner,
    MDBInput,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { confirmDeletePagingroupInPhones, getAccountLevelPagingGroupsList } from "../../../../src/apiclients/streamsapi_bridge";
import PopupLoader from "../../../views/popups/PopupLoader";
import AddPagingPopup from "../../../views/popups/phonesystem/AddPagingGroup";
import RemovePagingGroup from "../../../views/popups/phonesystem/RemovePagingGroup";
import UIConstant from "../../../apiclients/UIConstant";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../CustomSearchUtil/CustomSearch";
import TabIDConstant from "../../../apiclients/TabIDConstant";
import { useRef } from "react";


function PagingGroups(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const [pagingGroupModal, setPagingGroupModal] = useState(false);
    const [removePageinggroup, setRemovePageinggroup] = useState(false);
    const [removeGroupInfoRecord, setRemoveGroupInfoRecord] = useState();
    const [isloading, setIsloading] = useState(false);
    const [apiData, setApiData] = useState();
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [accountPagingGroups, setAccountPagingGroups] = useState([]);
    const [fullPagingGroups, setFullPagingGroups] = useState([]); 
    const [searchValue,setsearchValue] = useState("");
    const toggleAddPagingPopup = () => setPagingGroupModal(!pagingGroupModal);
    const toggleRemovePagingPopup = () => setRemovePageinggroup(!removePageinggroup);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, props.active);
    const basicData4 = {
        // columns: ["Paging Group", "Group ID", "Remove"],
        // rows: [
        //     ["Poly VVX 601", "1", "X"],
        //     ["Poly VVX 601", "2", "X"],
        //     ["Poly VVX 601", "3", "X"],
        //     ["Poly VVX 601", "4", "X"],
        // ],


        // columns: {[ label: "Paging Group", field: "groupname", sort: true },
        // { label: "Group ID", field: "groupno", sort: true },
        // { label: "Remove", field: "Remove", sort: false },],

        // rows: accountPagingGroups,

        columns: [
            {
                label: "Paging Group",
                field: "groupname",
                sort: true
            },
            {
                label: "Group ID",
                field: 'groupno',
                sort: true
            },
            {
                label: 'Remove',
                field: 'delete',
                sort: false,
            },
        ],
        rows: accountPagingGroups,
    };


    const handleDeletePagingGroup = async(evntData, groupinfoJo) => {
    
        evntData.preventDefault();
        evntData.stopPropagation();
        console.log("IN handleDeletePagingGroup :groupinfo to delete :" + JSON.stringify(groupinfoJo));
        if (groupinfoJo != null && groupinfoJo !== 'undefined' && Object.keys(groupinfoJo).length > 0) {
            console.log("[handleDeletePagingGroup] groupinfoJo  : " + groupinfoJo);
            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            let paramjo = {};
            paramjo.siteid = siteid;
            paramjo.paging_id = groupinfoJo.pagingId;
            paramjo.group_no = groupinfoJo.groupno;
            let serverResponse = await confirmDeletePagingroupInPhones(siteid, paramjo);
            if (!serverResponse.ok) {
                console.log("Network response was not ok !! delete BLF Group");
            } else {
                let response = await serverResponse.json();
                if (response.configuredMacs.length > 0) {
                    let macAdress = "";
                    let macs = response.configuredMacs;
                    console.log("macs ::::::::::::::: " + JSON.stringify(macs))
                    for (let item of macs) {
                        console.log("item ::::: " + JSON.stringify(item));
                        macAdress += item.macaddress + " ";
                    }
                    groupinfoJo.devices = macAdress.trim();
                    setRemoveGroupInfoRecord(groupinfoJo);
                    toggleRemovePagingPopup(removePageinggroup);
                    console.dir(response);
                } else {
                    setRemoveGroupInfoRecord(groupinfoJo);
                }
                toggleRemovePagingPopup(removePageinggroup);
            }
        }

    }

    /*Added By :Ganesh
     * This method will remove existing state for  roauter    
     */
    const removeStateVariables = () => {
        console.log("")
        navigate("/pslanding", {
            state: null,
        });
    }
    const fetchAccountLevelPagingGropups = async () => {
        setIsloading(true);
        console.log(" Making Fetch Api Request to get AccountLevelPagingGropups :");
        let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        let serverResponse = await getAccountLevelPagingGroupsList(siteid, TabIDConstant.PAGING_GRPS_SUBLINK);

        if (!serverResponse.ok) {
            console.log("Network response was not ok");
            setIsloading(false);
            throw new Error('Network response was not ok');
        } else {

            let responseData = await serverResponse.json()
            let apiData = responseData.paging_groups_list;
            console.log("PagingGropups from node Server response : " + JSON.stringify(apiData));
            setApiData(apiData);
            let groupsData = [];
            apiData.forEach(element => {
                var json = {};
                json.groupname = element.group_name;
                json.groupno = element.group_no;
                json.pagingId = element.paging_id;
                json.delete =
                    <div className="d-flex align-items-center justify-content-center ms-2">
                        <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(event) => handleDeletePagingGroup(event, json)}>
                            <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                        </div>
                    </div>

                // <span title="Remove"><i className="ms-3 fas fa-xmark text-primary" onClick={(event) => handleDeletePagingGroup(event, json)}></i></span>;
                groupsData.push(json);
            });
            setAccountPagingGroups(groupsData);
            setFullPagingGroups(groupsData);
            setTimeout(() => {
                setIsloading(false);
            }, 1000);
        }
        removeStateVariables();
         setTimeout(() => {
        setDataLoaded(true)

        },1000)
    };
    useEffect(() => {
        fetchAccountLevelPagingGropups();
    }, []);

    function showThisInf(evntData) {
        console.log("evntData ::::::::: " + JSON.stringify(evntData));
        navigate("/SelectedPagingGroups", {
            state: {
                groupno: evntData.groupno, groupname: evntData.groupname,pagingId:evntData?.pagingId,pagingGroups: apiData
            },
        });
    }

    const handlePagingSearch = (searchValue) => {
        try {
            setsearchValue(searchValue);
            const filteredPagingGroups = customSearch(fullPagingGroups, searchValue, UIConstant.PAGINGGROUPS_FIELDS);
            setAccountPagingGroups(filteredPagingGroups);
        } catch (error) {
            console.log(" [handlePagingSearch] Error" + error);
        }
    }
    return (
        <>
            <h5 className="tabcontent actionbar">
                <MDBBtn
                    className="btn btn-primary green-button display-inline float-right"
                    onClick={toggleAddPagingPopup}
                    disabled={accountPagingGroups.length >= 25}
                >
                    <MDBIcon fas icon="plus" size="sm" /> {t("AddPagingGroup")}
                </MDBBtn>
            </h5>
            <div className='mb-2 mt-3 position-relative w-auto'>
                <MDBInput label="Search" 
                ref={searchRef} 
                value={searchValue} 
                onChange={(e) => handlePagingSearch(e.target.value)} />
                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
            </div>
            <div className="PagingGroupsDatatable">
                <MDBDatatable
                    //search
                    key={searchValue}
                    sortField="Paging Group"
                    noFoundMessage={t("NotFoundMessage")}
                    entries={UIConstant.DEFAULT_PAGINATION}
                    data={basicData4}
                    className="mt-2 actioncolumnbig"
                    onRowClick={(event) => {
                        showThisInf(event);
                    }}
                />
            </div>

            {pagingGroupModal && (
                <PopupLoader
                    title={"Add Paging Group"}
                    //content={<AddPagingPopup onClose={toggleAddPagingPopup} />}
                    content={<AddPagingPopup accountPagingGroups={accountPagingGroups} onClose={toggleAddPagingPopup} />
                    }
                    className={""}
                    onShow={setPagingGroupModal}
                    onClose={toggleAddPagingPopup}
                />
            )}
            {removePageinggroup && (
                <PopupLoader
                    title={"Remove Paging Group"}
                    content={<RemovePagingGroup onClose={toggleRemovePagingPopup} paramsJo={removeGroupInfoRecord} />}
                    className={""}
                    onShow={setRemovePageinggroup}
                    onClose={toggleRemovePagingPopup}
                />
            )
            }
            {isloading && (
                <div>
                    <div className="loadingclass-popup"></div>
                    <div className="popup-bg-loader loader_align">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </div>
            )}
            <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                Remove
            </Tooltip>
        </>
    )
}

export default PagingGroups;